import TextParticleManager from './text_particle_manager';
import * as utilities from './utilities';

TextParticleManager.utilities = utilities;

module.exports = TextParticleManager;